import copy from 'copy-to-clipboard'
import { CONSTANTS } from '@app/core/constants/constants';
declare var require: any
const FileSaver = require('file-saver');
import { v4 as uuidv4 } from 'uuid';
const { detect } = require('detect-browser');
//import moment from 'moment';
import moment from 'moment-timezone'
import { AbstractControl, FormGroup } from '@angular/forms';
import { ApiResponseModel } from '@app/modules/shared/models/api-response-model';
import { AppStatusEnum, BrowserEnum, BrowserVersionSupportedEnum, ContentTypeEnum, EnvironmentEnum, OsEnum, SessionUserRole } from './enums/enums';
import { appMessageBase } from '@app/core/constants/app-message.constant';
import { IDateTime } from '../interfaces/date-base';
import { CommonUtils } from './common.utils';
import html2PDF from 'jspdf-html2canvas';
import { environment } from '@environment/environment';
import { APP_USER } from '@app/configs/app-settings.config';
import { Participant } from '../interfaces/participant.interface';



const browserInfo = getBrowserInfo();
///console.log('browserInfo', browserInfo)
/**
 * Get native js elemenet Navigator for devices
 */

/**
 * copy string data to clipboard
 * @param copiedContent 
 */
export function copyToClipboard(copiedContent: string) {
    try {
        navigator.clipboard.writeText(copiedContent).then(function () {
        }, function (err) { });
    } catch (error) {
        copy(copiedContent);
    }

}

/**
 * sortarray
 * @param arr 
 * @param expression 
 */
export function sortArray<T>(arr: T[], expression: (a: any, b: any) => number): T[] {
    return arr.sort(expression);
}

/**
 * get first char first last name
 * @param fullname 
 */
export function getFirstLastNameChar(fullname: string) {
    let val = ""
    try {
        if (fullname) {
            fullname = fullname.trim();
            fullname = fullname.replace(/[ ]+/gi, ' ');
            const fullnameArr = fullname.split(' ');
            val += fullnameArr[0][0];
            if (getArrayLength(fullnameArr) > 1) {
                val += fullnameArr[1][0]
            }
        }
    } catch { }
    return val;
}
/**
 * reload window
 */
export function winReload() {
    //console.trace('winReload')
    window.location.reload();
}
/**
 * get jwt token
 */
export function getToken() {
    try {
        return JSON.parse(window.localStorage[APP_USER]).authToken
    } catch {
        return null;
    }
}

/**
 * save/download file
 * @param url 
 * @param fileName 
 */
export function fileSaver(url: string, fileName: string) {

    FileSaver.saveAs(url, fileName);
}

/**
 * create blob using blob part and type
 * @param blobParts 
 * @param type 
 */
export function getBlob(blobParts: BlobPart[], type: string) {
    return new Blob(blobParts, { 'type': type });
}

export function getUtcTimeStamp() {
    var dateUtc = moment.utc()
    return dateUtc.format('_YYYYMMDD_HHmmss');
}


/**
 * get uuid
 */
export function getuuid() {
    return uuidv4();
}
/**
 * Get weebhook to save metadata [depricated]
 * @param sessionRecId 
 */
export function getWebhookSaveMeta(sessionRecId) {
    return "https://podcast-backend.softobiz.net/v1/api/recordings/file-upload-meta-data/" + sessionRecId
    // return `${environment.host}${appApiUrl.recording.updateLocalMeta}${sessionRecId}`
}
/**
 * format datetime with timezone
 * @param date 
 */
export function formatWithTimeZone(date) {
    var jun = moment(date);
    let t = jun.tz('UTC').format();
    return t;
}

/**
 * ajust timezone to remvoe tz form current datetime or etc.
 * @param date 
 */
export function adjustForTimezone(date) {
    var timeOffsetInMS = date.getTimezoneOffset() * 60000;
    date.setTime(date.getTime() - timeOffsetInMS);
    return date
}


/**
 * phone number validator
 * @param control 
 */
export function phoneNumberValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value) {
        var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        if (phoneRegex.test(control.value)) {
            var formattedPhoneNumber = control.value.replace(phoneRegex, "($1) $2-$3");
            if (formattedPhoneNumber !== control.value)
                control.setValue(formattedPhoneNumber);
        }
        else {
            return { 'isTel': true };
        }
    }
    return null;
}

/**
 * check password contain whitespace
 * @param control 
 */
export function strongPasswordValidator(control: AbstractControl): { [key: string]: boolean } | null {

    if (!control.value) {
        return;
    }
    let value = control.value//.trim();
    let hasMin8Char = value.length >= 8;
    let hasNumber = /\d/.test(value);
    let hasUpper = /[A-Z]/.test(value);
    let hasLower = /[a-z]/.test(value);
    let hasSpecial = /[`!”?$?%^&*()_–+={[}\]:;@‘~#|\<,>.?\/]/.test(value);
    let hasSpace = /[ ]/.test(value);
    const valid = hasMin8Char && hasNumber && hasUpper && hasLower && hasSpecial && !hasSpace;
    if (!valid) {
        return { 'pattern': true };
    }
    return null;
}

/**
 * password matcher
 * @param controlName 
 * @param matchingControlName 
 */
export function MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}

/**
 * Extract Error Msg
 * @param err 
 */
export function extractErrorMsg(err: any) {
    let errMsg = '';
    try {
        (err && err.error && err.error.message && (errMsg = err.error.message))
    } catch { }
    return errMsg;
}


/**
 * supported browsers
 */
export async function supportedBrowser() {
    return await browserInfo;
}

/**
 * get browser info
 * @returns 
 */
export async function getBrowserInfo() {
    try {
        const browser = detect();
        var supported = false;
        var msg = '', title = '';
        var version = 0, os: string = '', name = '';
        (browser && browser.version && (version = parseFloat(browser.version)));
        (browser && browser.os && (os = browser.os));
        (browser && browser.name && (name = browser.name.toLocaleLowerCase()));
        if (os === OsEnum.androidOS || os === OsEnum.iOS) {
            return {
                supported,
                msg: appMessageBase.mobileSupportMsg,
                title: appMessageBase.commingSoon,
                browser
            }
        }
        switch (name) {
            case BrowserEnum.chrome:
                if (version >= BrowserVersionSupportedEnum.chrome) {
                    supported = true;
                    let isBrave = await isBraveBrowser()
                    if (isBrave) {
                        title = appMessageBase.browserNotSupport;
                        msg = appMessageBase.braveMsg;
                        supported = false;
                    }
                }
                else {
                    title = appMessageBase.outdatedTitle;
                    msg = appMessageBase.outdatedChromeMsg;
                }
                break;
            case BrowserEnum.firefox:
                // if (version >= BrowserVersionSupportedEnum.firefox) {
                //     supported = true;
                // }
                title = appMessageBase.browserNotSupport;
                msg = appMessageBase.firefoxMsg;
                break;

            case BrowserEnum.safari:
                title = appMessageBase.browserNotSupport;
                msg = appMessageBase.safariMac
                break;

            case BrowserEnum.edge:
                title = appMessageBase.outdatedTitle;
                msg = appMessageBase.outdatedEdge
                break;

            case BrowserEnum.edgeChromium:
                if (version >= BrowserVersionSupportedEnum.edgeChromium) {
                    supported = true;
                }
                else {
                    title = appMessageBase.outdatedTitle;
                    msg = appMessageBase.outdatedEdge
                }
                break;
            default:
                break;
        }
        try {
            window['os'] = os;
            window['browser'] = name;
        } catch { }
        return {
            supported,
            msg,
            title,
            browser
        };
    } catch (error) {
        throw error;
    }
}

/**
 * get os anme
 * @returns 
 */
export function getOs() {
    return window['os'] as string
}

/**
 * get browser name
 * @returns 
 */
export function getBrowser() {
    return window['browser'] as string
}
/**
 * 
 * @returns 
 */
export function getHardRefreshCmd() {
    let cmd = '';
    try {
        const os = getOs();
        if (os === OsEnum.macOS || os === OsEnum.iOS) {
            cmd = `Cmd-Shift-R`;
        }
        else if (os.includes(OsEnum.windows)) {
            cmd = `Cmd-Shift-F5`;
        }
    } catch (error) { }
    return cmd;
}
/**
 * image file supported
 * @param mimeType 
 */
export function imageSupportedFormat(mimeType: string) {
    if (mimeType && typeof mimeType === 'string') {
        mimeType = mimeType.toLocaleLowerCase();
        let arr = ['image/jpeg', 'image/png'];
        if (arr.includes(mimeType)) {
            return true;
        }
    }
    return false;
}
/**
 * get gmt
 * @param date 
 */
export function removeTzFormISo(date: Date) {
    let t = new Date(new Date(date).toString().replace(/GMT.+/g, 'GMT'));
    return t;
}

/**
 * get ext by mime type
 * @param mtype 
 */
export function getExtentsionMime(mtype) {
    var re = [{
        m: 'video/x-matroska',
        e: 'mkv'
    }, {
        m: 'video/webm',
        e: 'webm'
    }].filter(x => x.m === mtype);
    return re.length > 0 ? re[0].e : null;
}
/**
 * Used to modified validation message for dynamic display
 * @param msg 
 * @param replacement 
 */
export function validationMsgDyn(msg: string, replacement: string) {
    if (msg && replacement) {
        return msg.replace('{field}', replacement)
    }
    return '';
}
/**
 * clean recording file name
 */
export function cleanRecName(name: string, removePart: boolean = false) {
    try {
        const PART = 'Part';
        name = name.replace(/(_host|_guest)?[0-9_]+\.[a-z0-9_]+/gi, '');
        if (isNameHasPart(name)) {
            name = name.replace(/-/gi, ' ');
            const partNo = name.substring(name.lastIndexOf(PART)).replace(PART, '')
            name = name.replace(`${PART}${partNo}`, ` ${PART} ${partNo}`);
            if (removePart) {
                name = name.replace('Part 1', '');
            }
        }
    } catch (error) {
        console.error(error);
    }
    return name ? name.trim() : '';
}

export function extractFilenameFromPath(file: string) {
    return file.split('/').pop();
}

export function isNameHasPart(name: string) {
    try {
        if (name.toLocaleLowerCase().includes('part')) {
            return true
        }
    } catch {
        return false;
    }
}

/**
 * check whether recording has multiple parts
 * @param rec 
 * @returns 
 */
export function isRecMultiParts(recFile: string, rec: any[]) {
    let isMultiPart = false;
    try {
        const name = recFile.substring(0, recFile.indexOf('-Part'));
        const hostGuest = recFile.includes('host') ? 'host' : 'guest';
        isMultiPart = rec.filter(f => f.name.includes(name) && f.name.includes(hostGuest))
            .filter(f => f.name.includes('Part')).length > 1
    } catch { }
    return isMultiPart;
}


/**
 * extract date time stamp from filename
 * @param recordingFileName 
 * @returns 
 */
export function extractDateFromFileStamp(recordingFileName: string) {
    try {
        const timeStamp = recordingFileName.match(/([0-9].+)|(_[0-9].+)/gi)[0];
        let splitStamp = timeStamp.match(/[0-9]+/gi);
        let date = splitStamp[0].match(/(^\d{4})|(\d{2})/gi).join('-');
        let time = splitStamp[1].match(/\d{2}/gi).join(':');
        const dateTime = date.concat(' ').concat(time)
        return new Date(dateTime);
    } catch (error) {
        throw error;
    }
}


/**
 * convert bytes to Gb
 */
export function convertByteToGb(bytes: number) {
    if (bytes) {
        let gb = Math.pow(1024, 3);
        return bytes / gb;
    }
    return 0;
}
/**
 * parse float as decimal
 * @param num 
 * @param dm 
 */
export function parseFlotDecimal(num: number, dm: number = 2) {
    try {
        num = Number(num);
        return parseFloat(num.toFixed(dm));
    } catch (error) {
        return num;
    }
}
/**
 * check whether api respose is valid or invalid
 */
export function isApiResponseValid(res: ApiResponseModel): boolean {
    try {
        if (res && res.status === AppStatusEnum.Success && res.data) {
            return true;
        }
    } catch (error) { }
    return false;
}

/**
 * format duration(seconds) into time
 * @param d eg:{10} sec
 * @returns string {hh:mm:ss}
 */
export function secondsToHms(d: number) {
    try {
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);
        var formatT = (t: number) => {
            return t > 0 ? (t < 10 ? '0' + t : t) : '00'
        }
        return `${formatT(h)}:${formatT(m)}:${formatT(s)}`;
    } catch (error) { }
}

/**
 * get current timezone of system eg:{America/new_york}
 * return string
 */
export function getCurrentTz() {
    try {
        return moment.tz.guess();
    } catch { }
}

/**
 * get time zone offset eg:{-04:00}  by timezone name eg:{America/new_york}
 * @param tzName eg:{America/Los_Angeles}
 * @returns 
 */
export function getOffsetByTzName(tzName: string) {
    try {
        //let value = moment().tz(tz).format('z');
        return moment().tz(tzName).format('Z');
    } catch (error) {
        throw error;
    }
}

/**
 * Get abbrevation of timezone by timezone name eg:{America/new_york} having abbrevation eg: {EDT}
 * @param tzVal eg:{America/new_york}
 * @returns string eg: {EDT}
 */
export function getAbbrevationTz(tzVal: string) {
    try {
        return moment().tz(tzVal).format('z');
    } catch (error) { }
}

/**
 * get list of timezone
 * @return array<Object> timezone
 */
export function listTz() {
    try {
        return moment.tz.names();
    } catch (error) { }
}

/**
 * convert blob to string buffer
 * @param blob 
 * @param type 
 * @returns 
 */
export function convertblobToStringBuffer(blob: Blob, type: string): Promise<{ buffer: string | ArrayBuffer, type: string }> {
    return new Promise((res, rej) => {
        var reader = new FileReader();
        reader.readAsArrayBuffer(blob);
        reader.onload = function (e) {
            res({
                buffer: e.target.result,
                type: type
            });
        };
    })
}

/**
 * convert blob to blob
 * @param blobarr 
 * @param type 
 * @returns 
 */
export function blob2ToBlob(blobarr, type) {
    return CommonUtils.blob2ToBlob(blobarr, type)
}

/**
 * before unload event
 * @param e 
 */
function beforeunloadEv(e: any) {
    e.preventDefault();
    e.returnValue = '';
}

/**
 * add before unload event
 */
export function addBeforeunloadEvent() {
    window.addEventListener('beforeunload', beforeunloadEv);
    // if (window.history && history.pushState) {
    //     addEventListener('load', function () {
    //         history.pushState(null, null, null);
    //         addEventListener('popstate', function () {
    //             var stayOnPage = confirm("Changes you made may not be saved.");
    //             if (!stayOnPage) {
    //                 history.back()
    //             } else {
    //                 //history.pushState(null, null, null);
    //             }
    //         });
    //     });
    // }
}

/**
 * redirect to landing page
 */
export function redirectLandingPage() {
    window.location.href = 'https://boomcaster.com/'
}
/**
 * format dateTime to ampm 12h
 * @param date 
 */
export function formatAMPM(date: Date) {
    try {
        const { hours, minutes, ampm } = getTime12h(date);
        let minutestr = minutes < 10 ? '0' + minutes : minutes;
        var strTime = `${hours}:${minutestr} ${ampm}`;
        return strTime;
    } catch (error) {
    }
}

/**
 * get time in 12 hours
 * @param date 
 * @returns 
 */
export function getTime12h(date: Date) {
    try {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        return {
            hours,
            minutes,
            ampm
        }
    } catch (error) { }
}

/**
 * format time to 24
 * @param time 
 * @returns 
 */
export function format12to24(time: string) {
    try {
        var hours = Number(time.match(/^(\d+)/)[1]);
        var minutes = Number(time.match(/:(\d+)/)[1]);
        var AMPM = time.match(/\s(.*)$/)[1];
        if (AMPM == "PM" && hours < 12) hours = hours + 12;
        if (AMPM == "AM" && hours == 12) hours = hours - 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        return (sHours + ":" + sMinutes);
    } catch (error) { }
}

/**
 * add time to date
 * @param date 
 * @param time24 
 * @returns 
 */
export function addTimeToDate(date: Date, time24: any) {
    try {
        var dt = new Date(date);
        dt.setHours(0, 0, 0);
        var arr = time24 ? time24.split(':') : [];
        if (arr) {
            dt.setHours(arr[0], arr[1]);
        }
        return dt;
    } catch (error) { }
}

/**
 * extended datetime object
 * @param date 
 * @returns 
 */
export function dateTimeObj(date: Date | string) {
    if (date) {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
            "July", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        //if (typeof date === 'string') {
        date = new Date(date);
        //}
        let dateTimeO: IDateTime = {
            weekDay: date.getDay(),
            dayName: dayNames[date.getDay() + 1],
            month: date.getMonth() + 1,
            monthName: monthNames[date.getMonth()],
            monthDay: date.getDate(),
            year: date.getFullYear(),
            hh: date.getHours(),
            mm: date.getMinutes(),
            time12h: formatAMPM(date),
            timeZone: '',
        }
        return dateTimeO;
    }
}

/**
 * convert utc to current timezone
 * @param date 
 * @returns 
 */
export function convertUtcToCurrentTz(date: string) {
    let nwdate = null;
    try {
        if (date && typeof date === 'string') {
            date = `${date} GMT+0`;
            nwdate = new Date(date);
            return nwdate;
        }
    } catch (error) { }
}

/**
 * get file from dataurl
 * @param dataurl 
 * @param filename 
 * @returns 
 */
export function dataURLtoFile(dataurl: string, filename: string) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}

/**
 * get base 64 of file
 * @param file 
 * @returns 
 */
export function fileBase64(file: any): Promise<string> {
    return new Promise((res, rej) => {
        let fileR = new FileReader();
        fileR.readAsDataURL(file);
        fileR.onloadend = (ev) => {
            res((ev.target.result as string))
        }
        fileR.onerror = (err) => {
            rej(err);
        }
    })
}

/**
 * get positions list
 * @returns 
 */
export function getPositions() {
    return [
        {
            name: 'Top left',
            id: 1,
            slug: 'top-left'
        },
        {
            name: 'Top right',
            id: 2,
            slug: 'top-right'
        },
        {
            name: 'Bottom left',
            id: 3,
            slug: 'bottom-left'
        },
        {
            name: 'Bottom right',
            id: 4,
            slug: 'bottom-right'
        },
    ]
}

/**
 * get video resoultion config
 * @returns 
 */
export function getVideoResoultion() {
    return [
        {
            id: 1,
            label: '480p (SD)',
            width: 852,
            height: 480
        },
        {
            id: 2,
            label: '720p (HD) - Recommended',
            width: 1280,
            height: 720
        }, {
            id: 3,
            label: '1080p (Full HD)',
            width: 1920,
            height: 1080
        }, {
            id: 5,
            label: '2k (Quad HD)',
            width: 2560,
            height: 1440
        }, {
            id: 4,
            label: '4k (Ultra HD)',
            width: 3840,
            height: 2160
        },
    ]
}

/**
 * get day of today in the month
 * @returns 
 */
export function getTodayMonthDay() {
    let day = moment().format('DD');
    return day;
}

/**
 * is array is valid and not empty
 * @param arr 
 * @returns 
 */
export function isArrayNotEmpty(arr: any[]) {
    return CommonUtils.isArrayNotEmpty(arr)
}

/**
 * check whether object has property
 * @param obj 
 * @param prop 
 * @returns 
 */
export function isObjectAndHasProperty(obj: any, prop: string) {
    try {
        return (obj !== null && typeof obj === 'object' && !Array.isArray(obj) && obj.hasOwnProperty(prop))
    } catch (error) {
        return false;
    }
}

/**
 * find property value from object
 * @param obj 
 * @param prop 
 * @returns 
 */
export function findPropValueInobj(obj: any, prop: string) {
    try {
        for (let e in obj) {
            if (typeof obj[e] === 'object' && !Array.isArray(obj[e])) {
                let res = findPropValueInobj(obj[e], prop);
                if (res) {
                    return res
                }
            }
            else if (typeof obj[e] === 'string' && e === prop) {
                return obj[e]
            }
        }
    } catch (error) { }
}

/**
 * add minutes in date
 * @param date 
 * @param min 
 * @returns 
 */
export function addMinute(date: Date, min: number) {
    const nD = new Date(date.getTime() + min * 6e4)
    return nD;
}

/**
 * add seconds 
 * @param date 
 * @param sec 
 * @returns 
 */
export function addSecond(date: Date, sec: number) {
    const nD = new Date(date.getTime() + sec * 1e3)
    return nD;
}

/**
 * create error response object
 * @param message 
 * @returns 
 */
export function createErrorObj(message: string) {
    try {
        return {
            error: {
                message
            }
        }
    } catch (error) {
    }
}

/**
 * get last week range for filter
 * @returns 
 */
export function getLastWeek() {
    try {
        return {
            start: moment().subtract(1, 'weeks').startOf('days').toDate(),
            end: moment().subtract(1, 'weeks').endOf('days').toDate()
        }
    } catch (error) { }
}
/**
 * get last month date
 * use this in case full last month not from the day : moment().subtract(1, 'month').startOf('month').toDate(),
 * @returns 
 */
export function getLastMonth() {
    try {
        return {
            start: moment().subtract(1, 'month').startOf('days').toDate(),
            end: moment().subtract(1, 'month').endOf('month').toDate()
        }
    } catch (error) { }
}

/**
 * get last year range filter
 * @returns 
 */
export function getLastYear() {
    try {
        return {
            start: moment().subtract(1, 'year').startOf('days').toDate(),
            end: moment().subtract(1, 'year').endOf('year').toDate()
        }
    } catch (error) { }
}

/**
 * extract single file
 * @param event 
 * @returns 
 */
export function extractFile(event: any) {
    try {
        return event.target.files.item(0);
    } catch (error) { }
}

/**
 * get file meata infromation
 * @param url 
 * @returns 
 */
export function getImageFileMeta(url: string): Promise<{ width: any, height: any, size: any }> {
    return new Promise((res, rej) => {
        let img = new Image();
        img.onload = function () {
            let _this: any = this;
            res({
                width: _this.width,
                height: _this.height,
                size: _this.sizes
            });
        };
        img.src = url;
    })
}

/**
 * check whether api url is external url
 * @param apiUrl 
 * @returns 
 */
export function isExternalUrl(apiUrl: string) {
    try {
        let external = ['googleapis', 'api.linkedin.com'];
        return external.some(p => apiUrl.includes(p));
    } catch (error) { }
}

/**
 * get image infromation
 * @param url 
 * @returns 
 */
export function getImgInfo(url: string): Promise<{ width: any, height: any, size: any }> {
    return new Promise((res, rej) => {
        let img = new Image();
        img.onload = function () {
            let _this: any = this;
            res({
                width: _this.width,
                height: _this.height,
                size: _this.sizes
            });
        };
        img.src = url;
    })
}

/**
 * handle promise with all settle status
 * wait till all promise settled
 * @param arr 
 * @returns 
 */
export async function promiseAllSettle(arr: any[]) {
    try {
        let promise = await (Promise as any).allSettled(arr) as Array<any>;
        let result = promise.map(result => result.value)
        return result;
    } catch (error) { }
}


export async function promiseAll(arr: any[]) {
    try {
        return (Promise as any).all(arr) as Array<any>;
    } catch (error) { }
}

/**
 * check whether browser is brave or not
 * @returns 
 */
async function isBraveBrowser(): Promise<any> {
    try {
        const navigatorO = navigator as any
        return (navigatorO.brave && await navigatorO.brave.isBrave() || false);
    } catch (error) {
        return false;
    }
}


/**
 * get length of array eg [1,2] length 2
 * @param arr array 
 * @returns number
 */
export function getArrayLength(arr: any[]) {
    let length = 0;
    try {
        if (isArrayNotEmpty(arr)) {
            length = arr.length;
        }
    } catch { }
    return length;
}


/**
 * generate pdf 
 * @param htmlNode 
 * @param cb 
 * @param output 
 */
export function generatePDF(htmlNode: any, cb: () => void, output: string = 'invoice.pdf') {
    html2PDF(htmlNode, {
        jsPDF: {
            format: 'a4',
        },
        html2canvas: {
            imageTimeout: 15000,
            logging: true,
            useCORS: false,
            scale: 3,
        },
        imageType: 'image/png',
        imageQuality: 100,
        output,
        success: function (pdf: any) {
            console.log('success')
            pdf.save(this.output);
            cb();
        }
    });
}

/**
 * convert miliseconds to minutes
 * @param miliseconds 
 * @returns 
 */
export function convertMilsecondsToMinute(miliseconds: number) {
    try {
        return miliseconds / 6e4
    } catch (error) {
    }
}

/**
 * get new date object
 * @param date 
 * @returns 
 */
export function toDate(date: any) {
    try {
        return new Date(date);
    } catch (error) {
    }
}

/**
 * parse unit 
 * custome parse unit method
 * @param unit 
 * @param option 
 * @returns 
 */
export function parseUnit(unit: string, option?: { default?: string, isUpperCase?: boolean, isFirstCharUpper?: boolean, isMany?: boolean }) {
    try {
        const isPlural = (val: string) => {
            try {
                if (val) {
                    return val.lastIndexOf('s') === val.length - 1;
                }
            } catch {
                return false;
            }
        }
        unit = unit === CONSTANTS.NONE ? (!option.default ? "" : option.default) : unit;
        unit = option.isUpperCase ? unit.toUpperCase() : unit;
        unit = option.isFirstCharUpper ? unit.replace(unit[0], unit[0].toUpperCase()) : unit;
        unit = !isPlural(unit) && option && option.isMany ? `${unit}s` : unit;
    } catch (error) { }
    return unit;
}

/**
 * check whether test or prod env
 * @returns 
 */
export function isTestEnv() {
    return environment.env === EnvironmentEnum.dev || environment.env === EnvironmentEnum.stage
}

export function isDevEnv() {
    return environment.env === EnvironmentEnum.dev;
}

/**
 * change extension
 * @param fileName 
 * @param ext 
 * @returns 
 */
export function changeExtension(fileName: string, ext: string) {
    return fileName.replace((fileName.split('.').pop()), ext)
}
/**
 * geneate script for updating timezone using moment for database
 * @param timezonesDb  list of timezones from database
 */
export function generateSqlScriptTimezone(timezonesDb: any[]) {
    timezonesDb.forEach(t => {
        let offest = getOffsetByTzName(t.value);
        console.log(`await queryRunner.query("update Timezone set offset='${offest}' where value = '${t.value}'");`)
    })
}

/**
 * open url 
 * @param url 
 * @param target 
 */

export function openUrl(url: string, target: '_blank' | '_self' | '_parent' | '_top' | 'framename') {
    try {
        window.open(url, target);
    } catch (error) {
        throw error;
    }
}

/**
 * play only one audio at a time
 * @param audioEvent 
 */
export function playOnlyOneAudio(audioEvent: any) {
    try {
        let eAudio = document.getElementsByTagName('audio')
        if (eAudio && eAudio.length > 0) {
            for (var i = 0; i < eAudio.length; i++) {
                if (audioEvent.target !== eAudio[i]) {
                    eAudio[i].pause();
                }
            }
        }
    } catch (error) {
        throw error;
    }
}

/**
 * throw custom exception
 * @param title 
 * @param message 
 * @param statusCode 
 */
export function throwCustomException(title: string, message: string, statusCode: number) {
    return { title, message, statusCode }
}



/**
 * check wheather object is valid or invalid
 * @param obj 
 * @returns 
 */
export function isObjectValidAndNotEmpty(obj: any) {
    try {
        return isArrayNotEmpty(Object.entries(obj));
    } catch (error) {
        return false;
    }
}

/**
 * sleep function by default 5sec 
 * @param time defatul 5 sec
 * @returns 
 */
export async function sleep(miliseconds: number = 5e3) {
    return CommonUtils.sleep(miliseconds);
}

/**
 * /[\s~`!@#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?()\._]/g
 */
export async function hasNameValidSpecialChar(name: string) {
    return !/[~!@#$%\^&*+=\\[\]\\;,/{}|\\":<>\?\._]/g.test(name);
}

/**
 * check whether web worker exist or not
 * @returns 
 */
export function isWebWorkerExist() {
    //disble for now
    return false;
    //
    //return typeof Worker !== 'undefined'
}

/**
 * get content type val from enum
 * @param contentType 
 * @returns 
 */
export function getContentTypeValFromEnum(contentType: string) {
    if (contentType.includes('mp4')) {
        return ContentTypeEnum.mp4;
    }
    else if (contentType.includes('mpeg')) {
        return ContentTypeEnum.mp3;
    }
}

export function getBooleanValue(value: any) {
    try {
        if (value) {
            if (typeof value === 'string') {
                return value === 'true'
            }
            else if (typeof value === 'boolean') {
                return value
            }
        }
    } catch { }
    return false;
}

/**
 * lighten or darken color
 * @param color 
 * @param percent 
 * @returns 
 */
export function lightenDarkenColor(color, percent) {
    try {
        var R = parseInt(color.substring(1, 3), 16);
        var G = parseInt(color.substring(3, 5), 16);
        var B = parseInt(color.substring(5, 7), 16);
        const getPer = (rgb, per) => {
            return (rgb * (100 + per) / 100).toString()
        }
        R = parseInt(getPer(R, percent));
        G = parseInt(getPer(G, percent));
        B = parseInt(getPer(B, percent));
        R = (R < 255) ? R : 255;
        G = (G < 255) ? G : 255;
        B = (B < 255) ? B : 255;
        var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
        var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
        var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));
        return "#" + RR + GG + BB;
    } catch (error) {
        return ''
    }
}

/**
 * get role from enum by extracting role query from url
 * @param roleQuery 
 */
export function getParticipantRole(roleQuery: string) {
    let role = SessionUserRole.guest;
    switch (roleQuery) {
        case 'p':
            role = SessionUserRole.producer
            break;
        case 'a':
            role = SessionUserRole.audience
            break;
    }
    return role;
}


/**
 * get role id from participant
 * @param participant 
 * @returns 
 */
export function getRoleIdFromParticipant(participant: Participant) {
    if (participant.info) {
        return +participant.info.externalId.split('-role-').pop();
    }
    return -1
}

/**
 * get operation system name and version
 * @returns string
 */
export async function getWindowOsInfo() {
    try {
        const navigatorO = navigator as any;
        const ua = await navigatorO.userAgentData.getHighEntropyValues([CONSTANTS.PLATFORMVERSION]);
        if (navigatorO.userAgentData.platform === CONSTANTS.WINDOWS) {
            const majorPlatformVersion = parseInt(ua.platformVersion.split('.')[0]);
            if (majorPlatformVersion >= 13) {
                return CONSTANTS.WINDOW_11 //"Windows 11 or later"
            }
            else if (majorPlatformVersion > 0) {
                return CONSTANTS.WINDOW_10;
            }
        }
    } catch (error) { }
    return CONSTANTS.WINDOWS
}

/**
 * find links in text content and convert to html
 * @param text 
 * @returns 
 */
export function urlify(text: string) {
    //var urlRegex = /(https?:\/\/[^\s]+)/g;
    var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(urlRegex, function (url) {
        return '<a href="' + url + '" target="_blank">' + url + '</a>';
    })
    // or alternatively
    // return text.replace(urlRegex, '<a href="$1">$1</a>')
}

/**
 * display video tile based on permission
 * @param participant 
 * @returns 
 */
export function isDisplayVideoTile(participant: Participant) {
    try {
        const roleId = getRoleIdFromParticipant(participant);
        if (SessionUserRole.guest === roleId || SessionUserRole.host === roleId) {
            return true;
        }
    } catch (error) {
        this.logger.error('isDisplayVideoTile', error);
    }
    return false;
}

export function getCleanAndSubstr(name: string, val: number = 4) {
    try {
        name = name.replace(/[^A-Z0-9]+/ig, "_");
        name = name.substring(0, val)
        return name;
    } catch {
        return ''
    }
}


/**
 * swap element of arry
 * @param array array to which swap operation perform
 * @param fromIdx swap element index number
 * @param toIdx swap element new position 
 */
export function swapItemArr<T>(array: T[], fromIdx: number, toIdx: number) {
    try {
        const toTemp = array[toIdx];
        array[toIdx] = array[fromIdx];
        array[fromIdx] = toTemp;
        return array;
    } catch (error) {
        throw error;
    }
}


/**
 * swap element of arry
 * @param array array to which swap operation perform
 * @param fromIdx swap element index number
 * @param toIdx swap element new position 
 */
export function swapParticipant(participants: Participant[], fromIdx: any, toIdx: any) {
    try {
        return swapItemArr(participants,fromIdx, toIdx);
        // const to = participants.findIndex(p => p.id === toIdx);
        // const from = participants.findIndex(p => p.id === fromIdx);
        // console.log('to %d from %d', to, from)
        // const toTemp = participants[to];
        // participants[to] = participants[from];
        // participants[from] = toTemp;
        // return participants;
    } catch (error) {
        throw error;
    }
}

